const quotationChat = {
  quotationChatNavLabel: "Chat de devis", // translated 
  quotationChatApprovalTitle: "Chat de devis", // translated 
  quotationChatAccountNotApprovedTitle: "Compte non approuvé", // translated 
  quotationChatAccountNotApprovedDescription:
    "Votre compte n'est pas encore approuvé. Veuillez contacter votre responsable de compte pour plus d'informations.", // translated 
  quotationChatViewAiChat: "Voir le chat I.A.", // translated 

  quotationRequestChatSessions: "Sessions de chat", // translated 
  quotationRequestChatNoPastSessions: "Aucune session passée", // translated 
  quotationRequestChatNewChat: "Nouveau chat", // translated 
  quotationRequestChatCloseSidebar: "Fermer la barre latérale", // translated 
  quotationRequestChatSessionFallback: "Session de chat", // translated 
  quotationRequestChatDefaultSessionName: "Nouvelle session de chat", // translated 
  quotationRequestChatTitle: "Chat de demande de devis", // translated 
  quotationRequestChatResponseLanguageLabel: "Langue de réponse", // translated 
  quotationRequestChatOpenSidebar: "Ouvrir la barre latérale", // translated 
  quotationRequestChatRenameSession: "Renommer la session", // translated 
  quotationRequestChatDeleteSession: "Supprimer la session", // translated 
  quotationRequestChatToggleDarkMode: "Basculer le mode sombre", // translated 
  quotationRequestChatSwitchToLightMode: "Passer au mode clair", // translated 
  quotationRequestChatSwitchToDarkMode: "Passer au mode sombre", // translated 
  quotationRequestChatEmptyStateHeading: "Démarrer une nouvelle conversation de demande de devis", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Décrivez vos besoins de voyage et je créerai une demande de devis pour vous.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Saisissez votre message pour démarrer une conversation... (Maj+Entrée pour une nouvelle ligne)", // translated 
  quotationRequestChatMessagePlaceholder: "Saisissez votre message... (Maj+Entrée pour une nouvelle ligne)", // translated 
  quotationRequestChatUploadFile: "Téléverser un fichier", // translated 
  quotationRequestChatUploadAttachment: "Téléverser une pièce jointe", // translated 

  quotationRequestChatStopGenerating: "Arrêter la génération", // translated 
  quotationRequestChatGenerateQuotation: "Générer un devis", // translated 
  quotationRequestChatGenerateFinalQuotation: "Générer le devis final", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Finaliser la demande de devis", // translated 
  quotationRequestChatHoldToRecord: "Maintenir pour enregistrer un message vocal", // translated 
  quotationRequestChatRecordingReleaseToSend: "Enregistrement en cours, relâcher pour envoyer", // translated 
  quotationRequestChatRecording: "Enregistrement...", // translated 
  quotationRequestChatSelectSessionFirst: "Veuillez d'abord sélectionner une session de chat.", // translated 
  quotationRequestChatCancelVoiceRecording: "Annuler l'enregistrement vocal", // translated 
  quotationRequestChatListening: "Écoutez...", // translated 
  quotationRequestChatTranscribing: "Transcription...", // translated 

  quotationRequestChatFileUploadedSuccess: "Fichier téléversé avec succès.", // translated 
  quotationRequestChatUnsupportedFileType: "Type de fichier non pris en charge. Veuillez téléverser un PDF, Word (.docx), Excel (.xlsx), PowerPoint (.pptx), texte/CSV ou une image.", // translated
  quotationRequestChatFailedCreateSession: "Échec de la création de la session de chat. Veuillez réessayer.", // translated 
  quotationRequestChatFailedUploadFile: "Échec du téléversement du fichier. Veuillez réessayer.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Veuillez répondre aux questions en attente avant d'envoyer un autre message.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Veuillez répondre aux questions en attente avant de finaliser la demande de devis.", // translated 
  quotationRequestChatFavoriteMarked: "Session de chat ajoutée aux favoris", // translated 
  quotationRequestChatFavoriteUnmarked: "Session de chat retirée des favoris", // translated 
  quotationRequestChatFailedSetFavorite: "Échec de l'ajout aux favoris", // translated 
  quotationRequestChatFailedUnsetFavorite: "Échec du retrait des favoris", // translated 
  quotationRequestChatRenamedSuccess: "Session de chat renommée avec succès.", // translated 
  quotationRequestChatFailedRename: "Échec du renommage de la session de chat. Veuillez réessayer.", // translated 
  quotationRequestChatDeletedSuccess: "Session de chat supprimée avec succès.", // translated 
  quotationRequestChatFailedDelete: "Échec de la suppression de la session de chat. Veuillez réessayer.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Pièce jointe démontée avec succès.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Échec de la suppression de la pièce jointe. Veuillez réessayer.", // translated 
  quotationRequestChatSubmittedSuccess:
    "Demande de devis soumise avec succès ! Votre demande est en cours de traitement.", // translated 
  quotationRequestChatFailedSubmit: "Échec de la soumission de la demande de devis", // translated 
  quotationChatPdfDownloadedSuccess: "PDF téléchargé avec succès !", // translated 
  quotationChatFailedGeneratePdf: "Échec de la génération du PDF", // translated 

  quotationRequestChatSubagentRequired:
    "Veuillez sélectionner un utilisateur sous-agent avant de soumettre la demande de devis.", // translated 
  quotationRequestChatAppUserLoading:
    "Votre profil utilisateur de l'application CRM est encore en cours de chargement. Veuillez réessayer dans un instant.", // translated 
  quotationRequestChatAppUserMismatch:
    "Votre profil utilisateur de l'application CRM ne correspond pas à cette session de chat.", // translated 

  quotationRequestChatRenameTitle: "Renommer la session de chat", // translated 
  quotationRequestChatSessionName: "Nom de la session", // translated 
  quotationRequestChatEnterSessionName: "Saisir le nom de la session", // translated 
  quotationRequestChatSaving: "Enregistrement...", // translated 
  quotationRequestChatSave: "Économiser", // translated 
  quotationRequestChatDeleteTitle: "Supprimer la session de chat", // translated 
  quotationRequestChatDeleteConfirm: "Etes-vous sûr de vouloir supprimer cette session de chat ?", // translated 
  quotationRequestChatDeleteCannotUndo: "Cette action est irréversible.", // translated 
  quotationRequestChatDeleting: "Suppression...", // translated 
  quotationRequestChatDelete: "Supprimer", // translated 

  quotationRequestChatAttachmentsTitle: "Pièces jointes du chat de demande de devis", // translated 
  quotationRequestChatLoadingAttachments: "Chargement des pièces jointes...", // translated 
  quotationRequestChatNoAttachments: "Aucune pièce jointe trouvée", // translated 
  quotationRequestChatDeleteAttachment: "Supprimer la pièce jointe", // translated 
  quotationRequestChatUploadingAttachment: "Téléversement de la pièce jointe...", // translated 
  quotationRequestChatUploadingAttachmentWait: "Veuillez patienter pendant le téléversement de votre fichier.", // translated 

  quotationRequestChatAnswerPendingQuestions: "Répondre aux questions en attente", // translated 
  quotationRequestChatProposeOwnAnswer: "Proposer ma propre réponse", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Saisissez votre propre réponse...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{answered}} sur {{total}} répondues", // translated 
  quotationRequestChatReadyToSubmit: "Prêt à soumettre", // translated 
  quotationRequestChatSubmitAll: "Tout", // translated 
  quotationRequestChatRespondToOneQuestion: "Répondre à {{count}} question", // translated 
  quotationRequestChatRespondToManyQuestions: "Répondre à {{count}} questions", // translated 

  quotationRequestChatFinalizeTitle: "Finaliser la demande de devis", // translated 
  quotationRequestChatLoadingSessionData: "Chargement des données de session...", // translated 
  quotationRequestChatErrorLoadingSession: "Erreur lors du chargement des données de session. Veuillez réessayer.", // translated 
  quotationRequestChatQuotationTitle: "Titre du devis", // translated 
  quotationRequestChatExtraComments: "Commentaires supplémentaires", // translated 
  quotationRequestChatSubmitting: "Soumission...", // translated 
  quotationRequestChatSubmit: "Soumettre", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Soumission de la demande de devis...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Veuillez patienter pendant la soumission de votre demande de devis.", // translated 

  quotationRequestChatSelectSubagent: "Sélectionner un sous-agent", // translated 
  quotationRequestChatSearchSubagents: "Rechercher des sous-agents...", // translated 
  quotationRequestChatLoadingSubagents: "Chargement des sous-agents...", // translated 
  quotationRequestChatNoSubagentsFound: "Aucun sous-agent trouvé", // translated 
  quotationRequestChatNoSubagentsAvailable: "Aucun sous-agent disponible", // translated 
  quotationRequestChatSelectedSubagent: "Sélectionné : {{label}}", // translated 

  quotationRequestChatSubagentUsers: "Utilisateurs sous-agents", // translated 
  quotationRequestChatSearchUsers: "Rechercher des utilisateurs...", // translated 
  quotationRequestChatNoUsersFound: "Aucun utilisateur trouvé", // translated 
  quotationRequestChatNoUsersAvailable: "Aucun utilisateur disponible", // translated 

  quotationChatDownloadSummaryTitle: "Télécharger le CV de votre appareil", // translated 
  quotationChatDownloadSummaryDescription:
    "Renseignez vos coordonnées ci-dessous pour générer un curriculum vitae PDF personnalisé de votre devis de voyage. Le PDF comprend tous les détails du voyage, les destinations, les informations de transport et l'itinéraire jour par jour.", // translated 
  quotationChatCustomerTitle: "Civilité", // translated 
  quotationChatSelectTitle: "Sélectionner la civilité", // translated 
  quotationChatHonorificMr: "M.", // translated 
  quotationChatHonorificMrs: "Mme", // translated 
  quotationChatHonorificMs: "Mlle", // translated 
  quotationChatHonorificDr: "Docteur", // translated 
  quotationChatHonorificProf: "Prof.", // translated 
  quotationChatCustomerPhone: "Téléphone", // translated 
  quotationChatCustomerCompany: "Société", // translated 
  quotationChatCustomerMessage: "Message", // translated 
  quotationChatCustomerCountry: "Pays", // translated 
  quotationChatGenerating: "Génération...", // translated 
  quotationChatDownloadPdf: "Télécharger le PDF", // translated 

  quotationChatTripSummary: "Résumé du voyage", // translated 
  quotationChatDownloadAsPdf: "Télécharger en PDF", // translated 
  quotationChatNoTripSummary: "Aucun résumé de voyage disponible pour cette session.", // translated 

  quotationRequestChatThinking: "Réflexion...", // translated 
  quotationRequestChatSources: "Sources", // translated 
  quotationRequestChatSearchingWebFor: 'Recherche sur le web pour : "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Services exécutés par le tour-opérateur", // translated 
  quotationRequestChatServicesByCustomer: "Services gérés par le client", // translated 
  quotationRequestChatReadyNotice:
    "Vous pouvez maintenant générer un devis pour cette demande en cliquant sur le bouton à droite.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Générer le devis final", // translated 

  quotationRequestChatMaybeYouWantToAsk: "Vous voudrez peut-être demander :", // translated 
  quotationRequestChatClickToSendSuggestion: "Cliquez pour envoyer ce message", // translated 

  quotationRequestChatAddToFavorites: "Ajouter aux favoris", // translated 
  quotationRequestChatRemoveFromFavorites: "Retirer des favoris", // translated 
  quotationRequestChatSubmitted: "Soumis", // translated 

  quotationRequestChatQuotationRequest: "Demande de devis : {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{titre}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Statut : {{statut}}", // translated 

  quotationChatLoading: "Chargement...", // translated 
  quotationChatSessionNotFound: "Session de chat introuvable pour ce devis", // translated 
  quotationChatMemberSessionNotFound: "Membre de la session introuvable pour votre compte", // translated 
  quotationChatUnableToConnect: "Impossible de se connecter au chat", // translated 
  quotationChatConnecting: "Rapport...", // translated 
  quotationChatTypeYourMessage: "Saisissez votre message...", // translated 
  quotationChatConnected: "Connecté", // translated 
  quotationChatConnectingStatus: "Rapport...", // translated 
  quotationChatDisconnected: "Déconnecté", // translated 
};


export default quotationChat;
